import { useAuth } from "@/components/Auth";
import Counties from "@/components/County";
import CountyAdmins from "@/components/CountyAdmins";
import Metrics from "@/components/Metrics";
import Users from "@/components/Users";
import { Stack, Tabs, Title } from "@mantine/core";
import { IconDashboardFilled, IconMap, IconUsersGroup } from "@tabler/icons-react";
import { useEffect } from "react";
import ReadOnlyAdminDashboard from "@/components/ReadOnlyAdminDashboard";

const AdminPage = () => {
    const {currentUser} = useAuth();
    useEffect(() => {
        document.title = "Admin Dashboard - Guard Dog Real Estate Protection Service";
    }, [])

    return (
        <Stack>
            <Title order={1} c='pq-red' style={{ fontFamily: 'Elston, sans-serif', letterSpacing: '2px' }}>PQ Admin</Title>
            <Tabs defaultValue="metrics" style={{width: '100%'}}>
                <Tabs.List>
                    <Tabs.Tab value="metrics" leftSection={<IconDashboardFilled size={14} />}>Stats</Tabs.Tab>
                    {(currentUser?.role?.toLocaleLowerCase() === "admin" || currentUser?.role?.toLocaleLowerCase() === "customersupport") && <Tabs.Tab value="users" leftSection={<IconUsersGroup size={14} />}>Users</Tabs.Tab>}
                    <Tabs.Tab value="county_admin" leftSection={<IconMap size={14} />}>County Admins</Tabs.Tab>
                    {currentUser?.role?.toLocaleLowerCase() === "admin" && <Tabs.Tab value="county_management" leftSection={<IconMap size={14} />}>County Management</Tabs.Tab>}
                    {(currentUser?.role?.toLocaleLowerCase() === "admin" || currentUser?.role?.toLocaleLowerCase() === "customersupport") && <Tabs.Tab value="read_only" leftSection={<IconMap size={14} />}>Dashboard</Tabs.Tab>}
                </Tabs.List>
                <Tabs.Panel m='md' value="metrics">
                    <Metrics />
                </Tabs.Panel>
                {(currentUser?.role?.toLocaleLowerCase() === "admin" || currentUser?.role?.toLocaleLowerCase() === "customersupport") &&  <Tabs.Panel m='md' value="users">
                    <Users />
                </Tabs.Panel>}
                {(currentUser?.role?.toLocaleLowerCase() === "admin"  || currentUser?.role?.toLocaleLowerCase() === "customersupport") && (<Tabs.Panel  m='md' value="county_admin">
                    <CountyAdmins />
                </Tabs.Panel>)}
                {currentUser?.role?.toLocaleLowerCase() === "admin" && (<Tabs.Panel  m='md' value="county_management">
                    <Counties />
                </Tabs.Panel>)}
                {(currentUser?.role?.toLocaleLowerCase() === "admin" || currentUser?.role?.toLocaleLowerCase() === "customersupport") &&  <Tabs.Panel m='md' value="read_only">
                    <ReadOnlyAdminDashboard />
                </Tabs.Panel>}
            </Tabs>
        </Stack>
    )
}
export default AdminPage;